'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.arrayToHash = arrayToHash;
exports.hashToArray = hashToArray;
exports.wrapReactClass = wrapReactClass;
exports.isString = isString;
exports.isObject = isObject;
exports.isFunction = isFunction;
exports.removeTailSlash = removeTailSlash;
exports.addHeadSlash = addHeadSlash;
exports.removeHeadSlash = removeHeadSlash;
exports.hasOwn = hasOwn;
exports.log = log;
exports.warn = warn;
exports.error = error;
exports.tryRender = tryRender;
exports.isVisibleOnDevice = isVisibleOnDevice;
exports.unwrapCode = unwrapCode;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _vuFunctionParser = require('@ali/vu-function-parser');

var _vuFunctionParser2 = _interopRequireDefault(_vuFunctionParser);

var _env = require('./env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var __SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = _react2.default.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

/**
 * Transform array to hash
 * @param  {Array} array
 * @param  {String} key   the selected key
 * @return {Object}
 */

function arrayToHash(array, key) {
  var data = {};
  array.forEach(function (value) {
    if (value[key]) {
      data[value[key]] = value;
    }
  });
  return data;
}

/**
 * Transform hash to array
 * @param  {Object} hash
 * @return {Array}
 */
function hashToArray(hash) {
  var arr = [];
  Object.keys(hash).forEach(function (key) {
    arr.push(hash[key]);
  });
  return arr;
}

/**
 * Wrap React Class for React Router.
 * @param {Object} Base
 * @param {Node} renderContent
 * @param {Object} propTypes
 * @param {Object} defaultProps
 * @returns {ReactClass}
 */
function wrapReactClass(Base, renderContent) {
  var _class, _temp;

  var propTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var defaultProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var ReactClass = (_temp = _class = function (_Base) {
    _inherits(ReactClass, _Base);

    function ReactClass() {
      _classCallCheck(this, ReactClass);

      return _possibleConstructorReturn(this, _Base.apply(this, arguments));
    }

    ReactClass.prototype.render = function render() {
      return renderContent(this.props);
    };

    return ReactClass;
  }(Base), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp);

  return ReactClass;
}

function isString(s) {
  return typeof s === 'string';
}

function isObject(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isFunction(f) {
  var funcTag = '[object Function]';
  var genTag = '[object GeneratorFunction]';
  var proxyTag = '[object Proxy]';
  var tag = typeof f === 'function' ? Object.prototype.toString.call(f) : '';
  return tag === funcTag || tag === genTag || tag === proxyTag;
}

function removeTailSlash(path) {
  if (path !== '/' && isString(path) && path.charAt(path.length - 1) === '/') {
    return path.slice(0, -1);
  }
  return path;
}

function addHeadSlash(path) {
  if (isString(path) && path.charAt(0) !== '/') {
    return '/' + path;
  }
  return path;
}

function removeHeadSlash(path) {
  if (isString(path) && path.charAt(0) === '/') {
    return path.slice(1);
  }
  return path;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

function hasOwn(obj, property) {
  return hasOwnProperty.call(obj, property);
}

function log() {
  if ((0, _env.isDev)() || (0, _env.isRenderLog)()) {
    for (var _len = arguments.length, content = Array(_len), _key = 0; _key < _len; _key++) {
      content[_key] = arguments[_key];
    }

    if (console.log.apply) {
      var _console;

      (_console = console).log.apply(_console, content);
    } else {
      // for IE9
      var consoleLog = Function.prototype.bind.call(console.log, console);
      consoleLog.apply(console, content);
    }
  }
}

function warn() {
  for (var _len2 = arguments.length, content = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    content[_key2] = arguments[_key2];
  }

  if (console.log.apply) {
    var _console2;

    (_console2 = console).warn.apply(_console2, content);
  } else {
    var consoleLog = Function.prototype.bind.call(console.warn, console);
    consoleLog.apply(console, content);
  }
}

function error() {
  for (var _len3 = arguments.length, content = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    content[_key3] = arguments[_key3];
  }

  if (console.log.apply) {
    var _console3;

    (_console3 = console).error.apply(_console3, content);
  } else {
    var consoleLog = Function.prototype.bind.call(console.error, console);
    consoleLog.apply(console, content);
  }
  // let e = { stack: '' };
  // if (isObject(content[0]) && content[0].stack) {
  //   e = content.shift();
  // }
  // const AliMonitor = window.AliMonitor = window.AliMonitor || [];
  // AliMonitor.push({
  //   msg: content.join(),
  //   stack: e.stack.slice(0, 1660),
  // });
}

function tryRender(View, props) {
  var result = true;
  try {
    if (__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) {
      var renderToStaticMarkup = __SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.renderToStaticMarkup;

      renderToStaticMarkup(_react2.default.createElement(View, _extends({}, props, { children: [] })));
    } else if (_react2.default.addons && _react2.default.addons.TestUtils) {
      var renderer = _react2.default.addons.TestUtils.createRenderer();
      renderer.render(_react2.default.createElement(View, _extends({}, props, { children: [] })));
    } else {
      warn('The current React version ' + _react2.default.version + ' is not support pre-render.');
    }
  } catch (e) {
    result = false;
    error(e.message, 'Check the component \'' + props.componentName + '\'.');
    log('Current props: ', props);
  }
  return result;
}

function isVisibleOnDevice(visibility, device) {
  if (visibility === false) {
    return false;
  }

  if (visibility) {
    if (device === 'DEFAULT') {
      return true;
    }
    if (Array.isArray(visibility) && visibility.indexOf(device) < 0) {
      return false;
    }
  }

  return true;
}

function unwrapCode(obj) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    useCompiled: true,
    useVariableValue: false,
    useParsedFunction: false,
    useIsolateWindow: false,
    isolateWindow: undefined
  };
  var useCompiled = options.useCompiled,
      useVariableValue = options.useVariableValue,
      useParsedFunction = options.useParsedFunction,
      useIsolateWindow = options.useIsolateWindow,
      isolateWindow = options.isolateWindow;


  if (!obj) return obj;

  if (Array.isArray(obj)) {
    return obj.map(function (item) {
      return unwrapCode(item, options);
    });
  }
  if (isObject(obj)) {
    if (hasOwn(obj, 'compiled') && hasOwn(obj, 'source') && useCompiled) {
      if (useParsedFunction) {
        var func = void 0;
        if (useIsolateWindow) {
          func = (0, _vuFunctionParser2.default)(obj.compiled, isolateWindow);
        } else {
          func = (0, _vuFunctionParser2.default)(obj.compiled);
        }
        return func;
      }
      return obj.compiled;
    }

    if (obj.type === 'variable' && obj.value != null && useVariableValue) {
      return obj.value;
    }

    var out = {};
    Object.keys(obj).forEach(function (key) {
      out[key] = unwrapCode(obj[key], options);
    });
    return out;
  }

  return obj;
}